import React, { useEffect } from 'react';
import DashboardContainer from 'containers/dashboard/DashboardContainer';
import AppTemplate from 'components/base/template/AppTemplate';
import AppNav from 'components/base/nav/AppNav';
import { useShallowAppSelector } from 'store/hooks';
import { isLogInSelector } from 'store/modules/auth';
import storage from 'lib/storage';
import { useHistory } from 'react-router-dom';

function Dashboard() {
  const { isLogIn } = useShallowAppSelector(state => ({ isLogIn: isLogInSelector(state) }));
  const history = useHistory();
  const returnPath = storage.get('returnPath');

  // login 완료되는 시점 returnPath 이동
  // useEffect(() => {
  //   if (isLogIn && returnPath) {
  //     storage.remove('returnPath');
  //     history.push(returnPath);
  //   }
  // }, []);

  return (
    <AppTemplate
      title={'Dashboard'}
      leftSide={<AppNav />}
      mainStyle={{
        // padding: '0 50px',
        padding: '0 0 0 40px',
      }}
    >
      <DashboardContainer />
    </AppTemplate>
  );
}

export default Dashboard;

/*
<DashboardTemplate
  nav={<NavContainer type="dashboard" />}
  rightSpace={<NavContainer type="executor" />}
  childrenStyleConf={{
    padding: '0',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    overflow: 'unset',
  }}
>
  <DashboardContainer />
</DashboardTemplate>
*/
